export default __webpack_public_path__ + "static/media/HimaniPatel_Resume_2.4a2dd894.pdf";